import { Injectable } from "@angular/core";
import { User } from "./auth.interfaces";
import { environment } from "@env/environment";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";
import { map } from "rxjs/operators";
import { ConfigService } from "@app/config.service";

@Injectable({ providedIn: "root" })
export class AuthenticationService {
  userSubject = new BehaviorSubject<Partial<User>>({});
  url: string;

  constructor(private configService: ConfigService) {
    this.url = this.configService.getUrlApi("api/Account/");

    this.userSubject = new BehaviorSubject<Partial<User>>(
      JSON.parse(localStorage.getItem(environment.tokenKeyName))
    );

    this.configService.configurationSubject.subscribe(
      () => (this.url = this.configService.getUrlApi("api/Account/"))
    );
  }

  get currentUserValue(): Partial<User> {
    return this.userSubject?.value;
  }

  login(UserName: string, Password: string) {
    return this.configService.http
      .post(`${this.url}Login`, {
        UserName,
        Password,
      })
      .pipe(
        map((user: User) => {
          localStorage.setItem(environment.tokenKeyName, JSON.stringify(user));
          this.userSubject.next(user);
          return user;
        })
      );
  }

  isAuthenticated() {
    return this.currentUserValue != null;
  }

  signout() {
    localStorage.removeItem(environment.tokenKeyName);
    location.reload();
  }
}
